/**
 * ChordTrackToggle Component
 * Toggle for Chord Track visibility
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Music } from 'lucide-react';

export const ChordTrackToggle = ({
  showChordTrack,
  setShowChordTrack,
  isSimplifiedMode = false,
}) => {
  if (isSimplifiedMode) return null;
  
  return (
    <Button
      variant={showChordTrack ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setShowChordTrack(!showChordTrack)}
      className={`relative p-2 ${showChordTrack ? 'bg-indigo-500/20 text-indigo-400 border border-indigo-500/50' : 'text-zinc-400 hover:text-white'}`}
      data-testid="chord-track-toggle"
      title="Toggle Chord Track"
    >
      <Music className="w-5 h-5" />
    </Button>
  );
};

export default ChordTrackToggle;
